// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".st2[data-v-770748dc] {\n  fill: #fff\n}\n.st96[data-v-770748dc] {\n  fill: #d96891\n}\n.st100[data-v-770748dc] {\n  fill: #d65678\n}\n", ""]);
// Exports
module.exports = exports;
